import { z } from 'zod';
import { strictRemoteCodec } from "./remote-codec.js";
import { DiagnosticsRowSchema, DiagnosticsViewSchema } from "./diagnostics-types.js";
export const ClientDiagnosticsBatchSchema = z.object({
    epoch: z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER),
    rows: z.array(DiagnosticsRowSchema.refine(row => row.layer === 'client')).max(128),
    dropped: z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER).optional(),
    unconfirmed: z.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER).optional(),
}).strict();
const result = strictRemoteCodec('dsh-github-copilot#DiagnosticsView', DiagnosticsViewSchema);
const contribution = {
    package: 'dsh-github-copilot',
    descriptors: [
        { method: 'get', parameters: [] },
        { method: 'clear', parameters: [] },
        { method: 'setEnabled', parameters: [{ name: 'enabled', wire: 'enabled', source: 'json',
                    codec: strictRemoteCodec('dsh-github-copilot#DiagnosticsEnabled', z.boolean()) }] },
        { method: 'recordClient', parameters: [{ name: 'batch', wire: 'batch', source: 'json',
                    codec: strictRemoteCodec('dsh-github-copilot#ClientDiagnosticsBatch', ClientDiagnosticsBatchSchema) }] },
    ].map(descriptor => ({ ...descriptor, id: `dsh-github-copilot:githubCopilotDiagnostics.${descriptor.method}`,
        namespace: 'githubCopilotDiagnostics', service: 'githubCopilotDiagnostics', invocation: { kind: 'direct' }, result })),
};
export default contribution;
//# sourceMappingURL=diagnostics-remote.js.map